module.exports = __webpack_public_path__ + "static/media/empty_subfolder.2af777f0.svg";